module.exports = __webpack_public_path__ + "img/ynbtrade-bg.8d9e61fe.jpg";